import DashboardLayout from "@/layouts/DashboardLayout";
import * as g from '@/apps/auth/router/guards';

export default {
  path: "/appeals",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Appeals",
      component: () => import("@/apps/appeals/components/AppealsPage"),
      props: true,
      beforeEnter: g.ifAuthenticated,
      meta: { name: "Заявки", backRoute: { label: 'Назад', name: 'Main'} }
    },
    {
      path: '/appeals/new',
      name: 'CreateAppeal',
      component: () => import('@/apps/appeals/components/AppealsCreate'),
      beforeEnter: g.ifAuthenticated,
      meta: { name: 'Создание заявки', backRoute: { label: 'Назад', name: 'Appeals' } }
    },
    {
      path: '/appeals/:id',
      name: 'AppealsDetail',
      component: () => import('@/apps/appeals/components/AppealsDetail'),
      props:       true,
      beforeEnter: g.ifAuthenticated,
      meta: { name: 'Информация о заявке', backRoute: { label: 'Назад', name: 'Appeals' } }
    },
  ]
};
